import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { CustomerBooking } from "rsl-api-106/lib/types";

type TradedoublerTrackingProps = {
  reservation: CustomerBooking;
};

const TradedoublerTracking: React.FC<TradedoublerTrackingProps> = ({
  reservation,
}) => {
  useEffect(() => {
    //le cart a fini de chargé et on a un cart et des résa
    if (reservation) {
      PixelCreate();
    }
  }, []);

  const PixelCreate = () => {
    let orderNumber = reservation.id?.toString(),
      orderValue = reservation.totalAmount?.amount,
      leadNumber = "",
      trackUrl = "",
      auto =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);

    // Parameter Option
    let extid = "email_adress",
      voucher = "VoucherCode",
      currency = "EUR",
      exttype = "",
      reportInfo = "Voir Doc";

    // Parameter TD Don't touch
    var org = "XXXXX",
      event = "XXXXX",
      isSale = true;

    function getCookie(name: string) {
      let dc = document.cookie;
      let prefix = name + "=";
      let begin = dc.indexOf("; " + prefix);
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
      } else {
        begin += 2;
      }
      let end = document.cookie.indexOf(";", begin);
      if (end == -1) {
        end = dc.length;
      }
      return unescape(dc.substring(begin + prefix.length, end));
    }

    let tduid = getCookie("DOUBLER");
    let valueNumber = leadNumber != "" ? leadNumber : auto;

    if (isSale) {
      trackUrl =
        "https://tbs.tradedoubler.com/report" +
        "?organization=" +
        org +
        "&event=" +
        event +
        "&ordernumber=" +
        orderNumber +
        "&orderValue=" +
        orderValue +
        "&currency=" +
        currency +
        (voucher != "VoucherCode" ? "&voucher=" + voucher : "") +
        (exttype != "" ? "&exttype=" + exttype : "") +
        (reportInfo != "Voir Doc"
          ? "&reportInfo=" + encodeURIComponent(reportInfo)
          : "") +
        (tduid != "" ? "&tduid=" + tduid : "") +
        "&type=iframe";
    } else {
      trackUrl =
        "https://tbl.tradedoubler.com/report" +
        "?organization=" +
        org +
        "&event=" +
        event +
        "&leadNumber=" +
        valueNumber +
        (extid != "email_adress" ? "&extid=" + extid : "") +
        (exttype != "" ? "&exttype=" + exttype : "") +
        (voucher != "VoucherCode" ? "&voucher=" + voucher : "") +
        (reportInfo != "Voir Doc"
          ? "&reportInfo=" + encodeURIComponent(reportInfo)
          : "") +
        (tduid != "" ? "&tduid=" + tduid : "") +
        "&type=iframe";
    }

    function Frame(TDurl: string) {
      const ifrm = document.createElement("iframe");
      ifrm.setAttribute("src", TDurl);
      ifrm.style.width = 1 + "px";
      ifrm.style.height = 1 + "px";
      ifrm.style.border = "none";
      document.body.appendChild(ifrm);
    }

    Frame(trackUrl);

    (function () {
      if (tduid) {
        var a = document.createElement("img");
        a.src =
          "https://img-statics.com/report?o=" +
          org +
          "&e=" +
          event +
          "&ordnum=" +
          (orderNumber != "XXXXXXX" ? orderNumber : valueNumber) +
          "&ordval=" +
          (orderValue != 0.0 ? orderValue : 1) +
          "&curr=" +
          currency +
          "&tduid=" +
          tduid +
          "&reportInfo=" +
          reportInfo;
        document.body.appendChild(a);
      }
    })();
  };

  return <></>;
};

TradedoublerTracking.propTypes = {
  //
};

export default TradedoublerTracking;
